<nav class="nav">
  <div
    class="nav__container"
    *ngFor="let layer of layers; let layerIndex = index;"
    [ngClass]="{ 'nav__container--active': layerIndex == (layers.length - 1) }"
  >
    <a
      class="nav__item nav__item--has-ancestor"
      [ngClass]="{ 'nav__item--hide': layerIndex == 0 }"
      (click)="onBack($event)"
      >Back</a
    >

    <div *ngFor="let item of layer">
      <a
        class="nav__item"
        *ngIf="item.url != null && !item.externalLink"
        [routerLink]="item.url"
        routerLinkActive="nav__item--active"
        >{{ item.name }}</a
      >

      <a
        class="nav__item"
        *ngIf="item.url != null && item.externalLink"
        [href]="item.url"
        routerLinkActive="nav__item--active"
        >{{ item.name }}</a
      >

      <a
        class="nav__item nav__item--has-children"
        *ngIf="item.items != null"
        (click)="onSelect($event, item)"
        >{{ item.name }}</a
      >
    </div>
  </div>

  <div
    class="nav__container"
    [ngClass]="{ 'nav__container--active': layers.length === 0 }"
  >
    <div class="nav__item">No menu items</div>
  </div>
</nav>
